import { useEffect, useState } from "react";

/**
 * Returns a Date that updates every `intervalMs` (default 30s).
 * Cheap, single setInterval, no resize listeners.
 */
export function useClock(intervalMs = 30_000): Date {
  const [now, setNow] = useState<Date>(() => new Date());
  useEffect(() => {
    // Align first tick to the next 30s boundary so seconds don't drift visibly.
    const ms = intervalMs - (Date.now() % intervalMs);
    let interval: ReturnType<typeof setInterval> | null = null;
    const timeout = window.setTimeout(() => {
      setNow(new Date());
      interval = setInterval(() => setNow(new Date()), intervalMs);
    }, ms);
    return () => {
      window.clearTimeout(timeout);
      if (interval) clearInterval(interval);
    };
  }, [intervalMs]);
  return now;
}

const timeFmt = new Intl.DateTimeFormat("de-DE", {
  hour: "2-digit",
  minute: "2-digit",
});
const dateFmt = new Intl.DateTimeFormat("de-DE", {
  weekday: "short",
  day: "2-digit",
  month: "short",
});

export function formatClockTime(d: Date): string {
  return timeFmt.format(d);
}
export function formatClockDate(d: Date): string {
  return dateFmt.format(d);
}
